import { useQuery } from "@tanstack/react-query"
import { Navigate, Outlet, useLocation } from "react-router-dom"

import { ApiError } from "@/lib/api"
import { useAuth } from "@/lib/auth"
import { api } from "@/lib/client"

export function RequireAuth() {
  const { initialized, session } = useAuth()
  const location = useLocation()
  const staffCheck = useQuery({
    enabled: Boolean(session),
    queryFn: () => api.customers(),
    queryKey: ["staff-check"],
    retry: false,
  })

  if (!initialized) {
    return <div className="flex h-dvh items-center justify-center text-sm text-muted-foreground">Loading…</div>
  }
  if (!session) {
    return <Navigate replace state={{ from: location }} to="/login" />
  }
  if (staffCheck.isPending) {
    return <div className="flex h-dvh items-center justify-center text-sm text-muted-foreground">Checking access…</div>
  }
  if (staffCheck.isError) {
    const err = staffCheck.error
    return (
      <Navigate
        replace
        state={{
          message: err instanceof Error ? err.message : "Staff check failed",
          status: err instanceof ApiError ? err.status : 0,
        }}
        to="/forbidden"
      />
    )
  }
  return <Outlet />
}
